export const defineCustomerType = {
  1 : {
    value: 1, label: 'Khách hàng'
  },
  2 : {
    value: 2, label: 'Khách hàng doanh nghiệp'
  },
  3 : {
    value: 3, label: 'Lead cũ (không dùng)'
  }
}
